<sans-dashboard
  [game]="biddingGame"
  [talonCards]="talonCards"
  [userCards]="userCards"
  [rightOpponentCards]="rightOpponentCards"
  [leftOpponentCards]="leftOpponentCards"
  [userPlayerScoreCard]="userPlayerScoreCard"
  [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
  [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
  [userActions]="userActions"
  (userActionSelected)="onUserActionSelected($event)"
>
</sans-dashboard>
